import { Options, Vue } from 'vue-class-component';
import { mapState } from 'vuex';

// import authService from '@/core/services/auth.service';
import { SET_APP_LOADING } from './core/store/action-types';
import { MANAGE_ELIOT_PARSE_EXCEPTION } from './core/utils/emitter-events';

@Options({
  name: 'App',
  computed: {
    ...mapState(['isLoading']),
  },
})
export default class App extends Vue {
  isAuthenticated: any = false;

  created() {
    this.$store.dispatch(SET_APP_LOADING, true);
    this.$emitter.on(
      MANAGE_ELIOT_PARSE_EXCEPTION,
      this.manageEliotParseException
    );
  }

  async mounted() {
    import(
      /* webpackChunkName: "auth-service" */ '@/core/services/auth.service'
    ).then(async (authService: any) => {
      this.isAuthenticated = await authService.default.handleRedirectPromise();

      if (this.isAuthenticated === 'logged_out') {
        this.$router.push({
          name: 'page-logged-out',
        });
      }

      this.$store.dispatch(SET_APP_LOADING, false);
    });
  }

  beforeUnmount() {
    this.$emitter.off(
      MANAGE_ELIOT_PARSE_EXCEPTION,
      this.manageEliotParseException
    );
  }

  manageEliotParseException() {
    this.$toast.add({
      severity: 'error',
      summary: this.$t('eliotParseException'),
      life: 3000,
    });
    // this.$router.push({
    //   name: 'page-plants-hub',
    // });
  }
}
